import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { ConfigBar, EditorContainer } from 'plugin-assets/shared/widget/components/styled'
import PreviewAndData from 'plugin-assets/shared/widget/multi-channel/editor/preview-and-data'
import Configs from './Configs'
import { LiveSelectedWidget } from 'live/webapp/types/widget'

type Props = {
    data: Record<string, any>
    tabs: ReactElement[]
    selectedWidget: LiveSelectedWidget
    widgetConfigActions: Record<string, any>
}

export default function DefaultEditor(props: Props): ReactElement {
    return (
        <ThemedEditorContainer className="editor-container default-editor">
            <ConfigBar>
                <Configs
                    widgetConfig={props.data.jsonConfig}
                    tabs={props.tabs}
                    type={props.selectedWidget.type}
                    changeConfig={props.widgetConfigActions.changeConfig}
                    changeLayoutConfig={props.widgetConfigActions.changeLayoutConfig}
                    isEditor={true}
                />
            </ConfigBar>
            <PreviewAndData
                {...props}
                hideSpanTypeSelector={props.selectedWidget.policies?.hideSpanTypeSelector}
                widget={props.data}
                isEmpty={false}
                isAssetSelected={true}
            />
        </ThemedEditorContainer>
    )
}

const ThemedEditorContainer = styled(EditorContainer)``
